import { Component, OnInit } from '@angular/core';
import { CostRejectionTemplateService } from '../../services/cost-rejection-template.service';
import { FormControl, FormGroup } from '@angular/forms';
import { compare } from 'fast-json-patch';
import { ConfirmationService, SelectItem } from 'primeng';
import { AdditionalChargeService, CommsTemplateService } from '../../services';

@Component({
  selector: 'additional-cost-questions',
  templateUrl: './additional-cost-questions.component.html',
  styleUrls: ['./additional-cost-questions.component.scss'],
})
export class AdditionalCostQuestionsComponent implements OnInit {
  isLoaded = false;
  additionalChargeQuestions: {}[] = [];
  responseSelected = null;
  editForm: FormGroup;
  showEditForm: boolean;
  editMode: boolean;
  private preEditForm: any;
  showHelp = false;
  wrapperOptions: SelectItem[];

  constructor(
    private additionalChargeService: AdditionalChargeService,
    private confirmationService: ConfirmationService,
    private commsTemplateService: CommsTemplateService,
  ) {}

  ngOnInit() {
    this.initForm();
    this.loadQuestions();
    this.loadWrappers();
  }

  initForm() {
    this.editForm = new FormGroup({
      id: new FormControl(),
      headline: new FormControl(),
      templateWrapperId: new FormControl(),
      recipientAddressTemplate: new FormControl(),
      subjectTemplate: new FormControl(),
      bodyTemplate: new FormControl(),

      senderAddressTemplate: new FormControl(),
      senderNameTemplate: new FormControl(),

      replyToAddressTemplate: new FormControl(),
      replyToNameTemplate: new FormControl(),
    });
  }

  loadQuestions() {
    this.isLoaded = false;

    this.additionalChargeService.RequestInfoChoiceSearch().then((x) => {
      this.additionalChargeQuestions = x;

      this.showEditForm = false;
      this.isLoaded = true;
    });
  }

  loadWrappers() {
    this.commsTemplateService.fetchTemplateWrappers().then((x) => {
      this.wrapperOptions = x.map((item) => {
        return { label: item.templateName, value: item.id };
      });

      this.wrapperOptions.unshift({ label: 'No Wrapper', value: null });
    });
  }

  createQuestion() {
    this.showEditForm = true;
    this.editMode = false;
    this.editForm.reset();
  }

  deleteQuestion() {
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete this item?',
      header: 'Confirmation',
      icon: 'pi pi-question',
      accept: () => {
        this.deleteConfirmed();
      },
    });
  }

  deleteConfirmed() {
    this.additionalChargeService.deleteAdditionalInfo(this.responseSelected.id).then((x) => {
      this.loadQuestions();
    });
  }

  editResponse(item) {
    this.showEditForm = true;
    this.responseSelected = item;
    this.editMode = true;
    this.editForm.patchValue(item);
    this.preEditForm = Object.assign(this.editForm.value);
  }

  get f() {
    return this.editForm.value;
  }

  saveResponse() {
    if (this.f.id > 0) {
      const patch = compare(this.preEditForm, this.editForm.value);

      this.additionalChargeService
        .patchAdditionalInfo(this.responseSelected.id, patch)
        .then((x) => {
          this.loadQuestions();
        });
    } else {
      this.additionalChargeService.createAdditionalInfo(this.editForm.value).then((x) => {
        this.loadQuestions();
      });
    }
  }
}
